import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, Scroll } from '@angular/router';
import { ViewportScroller } from '@angular/common';

// import { CarouselModule } from 'ngx-owl-carousel-o';
// import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
// import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';


import { AreaTecnologicaComponent } from './area-tecnologica/area-tecnologica.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CabecalhoComponent } from './cabecalho/cabecalho.component';
import { RodapeComponent } from './rodape/rodape.component';
import { NavbarComponent } from './cabecalho/navbar/navbar.component';
import { ApresentacaoComponent } from './apresentacao/apresentacao.component';
import { SobreComponent } from './sobre/sobre.component';
import { CursosComponent } from './cursos/cursos.component';
import { EixoTecnologicoComponent } from './eixo-tecnologico/eixo-tecnologico.component';
import { PrincipalComponent } from './principal/principal.component';
import { CursosMudaramNomeComponent } from './cursos/cursos-mudaram-nome/cursos-mudaram-nome.component';
import { DropdownComponent } from './cabecalho/navbar/dropdown/dropdown.component';
import { CursosExperimentaisComponent } from './cursos/cursos-experimentais/cursos-experimentais.component';

import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { CursosListaComponent } from './cursos/cursos-lista/cursos-lista.component';
import { CursosNaoPermitidosComponent } from './cursos/cursos-nao-permitidos/cursos-nao-permitidos.component';
import { CursoComponent } from './cursos/curso/curso.component';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada/pagina-nao-encontrada.component';
import { ListaTermosComponent } from './lista-termos/lista-termos.component';
import { TextoExperimentaisComponent } from './inclusao-experimental/texto-experimentais/texto-experimentais.component';
import { FaqComponent } from './faq/faq.component';

import { SugestoesCnctComponent } from './sugestoes-cnct/sugestoes-cnct.component';
import { CabecalhoCnctComponent } from './sugestoes-cnct/cabecalho-cnct/cabecalho-cnct.component';
import { TextoSugestaoCnctComponent } from './sugestoes-cnct/texto-sugestao-cnct/texto-sugestao-cnct.component';
import { SugestoesAreasComponent } from './sugestoes-areas/sugestoes-areas.component';
import { TextoSugestaoAreasComponent } from './sugestoes-areas/texto-sugestao-areas/texto-sugestao-areas.component';
import { CabecalhoCatalogosComponent } from './sugestoes-areas/cabecalho-catalogos/cabecalho-catalogos.component';
import { SugestoesComponent } from './sugestoes/sugestoes.component';
import { TextoSugestaoComponent } from './sugestoes/texto-sugestao/texto-sugestao.component';

import { CursosMudaramNomeTabelaConvergenciaComponent } from './cursos/cursos-mudaram-nome-tabela-convergencia/cursos-mudaram-nome-tabela-convergencia.component';
import { InclusaoExperimentalComponent } from './inclusao-experimental/inclusao-experimental.component';
import { CursosTabelaSubmissaoComponent } from './cursos/cursos-tabela-submissao/cursos-tabela-submissao.component';
import { LegislacaoComponent } from './legislacao/legislacao.component';

import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { BarraBuscaComponent } from './shared/barra-busca/barra-busca.component';
import { CardComponent } from './shared/card/card.component';
import { RemoveAsteristicoUnderlinePipe } from './shared/pipe/removeAsteristicoUnderline.pipe';
import { ShortenPipe } from './shared/pipe/shorten.pipe';
import { FormatPipe } from './shared/pipe/format.pipe';
import { NormalisePipe } from './shared/pipe/normalize.pipe';
import { TextToLinkPipe } from './shared/pipe/textToLink.pipe';
import { DropdownDirective } from './shared/directives/dropdown.directive';
import { Format2Pipe } from './shared/pipe/format2.pipe';
import { HigienizaHTML } from './shared/pipe/higienizaHTML.pipe';
import { RemoveEixoPipe } from './shared/pipe/removeEixo.pipe';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { DisplayDirective } from './shared/directives/display-more.directive';
import { RequiredTextComponent } from './shared/required-text/required-text.component';
import { SocialNetwoksComponent } from './shared/redes-sociais/redes-sociais.component';
import { PopUpComponent } from './shared/pop-up/pop-up.component';
import { TermsFormaterPipe } from './shared/pipe/termsFormater.pipe';
import { CustomFormComponent } from './shared/custom-form/custom-form.component';
import { PopUpConsultaComponent } from './shared/pop-up-consulta/pop-up-consulta.component';
import { PagerService } from './shared/service/pager.service';
import { HighlightPipe } from './shared/pipe/highlight.pipe';
import { Format3Pipe } from './shared/pipe/format3.pipe';
import { MenuComponent } from './cabecalho/menu/menu.component';
import { FormatTextPipe } from './shared/pipe/format-text.pipe';
import { FormatListaPipe } from './shared/pipe/format-lista.pipe';
import { FormatInfraestruturaMinimaPipe } from './shared/pipe/format-infraestrutura-minima.pipe';
import { FormatCargaHorariaPipe } from './shared/pipe/format-carga-horaria.pipe';
import { FormatPreRequisitoPipe } from './shared/pipe/format-pre-requisito.pipe';
import { FormatItinerarioInformativoPipe } from './shared/pipe/format-itinerario-informativo.pipe';
import { FormatCampoAtuacaoPipe } from './shared/pipe/format-campo-atuacao.pipe';
import { FormatQuebraLinhaPipe } from './shared/pipe/format-quebra-linha.pipe';
import { CitacaoModalComponent } from './shared/citacao-modal/citacao-modal.component';
import { EmBreveAvisoComponent } from './shared/em-breve-aviso/em-breve-aviso.component';
import { FormatExpedientePipe } from './shared/pipe/format-expediente.pipe';
import { PaginacaoComponent } from './shared/paginacao/paginacao.component';

@NgModule({
  declarations: [
    AppComponent,
    CabecalhoComponent,
    RodapeComponent,
    NavbarComponent,
    ApresentacaoComponent,
    SobreComponent,
    CursosComponent,
    EixoTecnologicoComponent,
    PrincipalComponent,
    FaqComponent,
    BreadcrumbComponent,
    CursoComponent,
    BarraBuscaComponent,
    CardComponent,
    PesquisaComponent,
    CursosListaComponent,
    PaginaNaoEncontradaComponent,
    RemoveAsteristicoUnderlinePipe,
    ShortenPipe,
    FormatPipe,
    NormalisePipe,
    TextToLinkPipe,
    CursosNaoPermitidosComponent,
    DropdownDirective,
    CursosMudaramNomeComponent,
    DropdownComponent,
    Format2Pipe,
    DisplayDirective,
    HigienizaHTML,
    RemoveEixoPipe,
    CursosExperimentaisComponent,
    SugestoesComponent,
    SpinnerComponent,
    RequiredTextComponent,
    SocialNetwoksComponent,
    PopUpComponent,
    ListaTermosComponent,
    TermsFormaterPipe,
    CustomFormComponent,
    InclusaoExperimentalComponent,
    PopUpConsultaComponent,
    TextoSugestaoComponent,
    TextoExperimentaisComponent,
    SugestoesCnctComponent,
    CabecalhoCnctComponent,
    TextoSugestaoCnctComponent,
    SugestoesAreasComponent,
    TextoSugestaoAreasComponent,
    CabecalhoCatalogosComponent,
    CursosMudaramNomeTabelaConvergenciaComponent,
    CursosTabelaSubmissaoComponent,
    LegislacaoComponent,
    AreaTecnologicaComponent,
    HighlightPipe,
    Format3Pipe,
    MenuComponent,
    FormatTextPipe,
    FormatListaPipe,
    FormatInfraestruturaMinimaPipe,
    FormatCargaHorariaPipe,
    FormatPreRequisitoPipe,
    FormatItinerarioInformativoPipe,
    FormatCampoAtuacaoPipe,
    FormatQuebraLinhaPipe,
    CitacaoModalComponent,
    EmBreveAvisoComponent,
    FormatExpedientePipe,
    PaginacaoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    // CarouselModule,
    // ShareButtonsModule,
    // ShareIconsModule,
  ],
  providers: [
    PagerService,
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'pt-BR',
    },
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA, // Informa ao Angular para aceitar elementos customizados
  ],

})
export class AppModule {
  constructor(private router: Router, private viewportScroller: ViewportScroller) {
    viewportScroller.setOffset([0, 60]);
    router.events.subscribe((e: Scroll) => {
      if (e.anchor) {
        setTimeout(() => {
          viewportScroller.scrollToAnchor(e.anchor);
        });
      } else if (e.position) {
        viewportScroller.scrollToPosition(e.position);
      } else {
        viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }
}
